import MAIndexPage from './MAIndexPage'
export { MAIndexPage }
export default MAIndexPage
